import { Box, styled } from '@mui/material';

const StyledLargeSessionCardDecoration = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(180deg, #C08300 33.62%, #F8B231 99.74%)',
  borderBottomLeftRadius: '12px',
  borderTopLeftRadius: '12px',
  width: '6px',
  [theme.breakpoints.up('sm')]: {
    width: '8px'
  }
}));

export default StyledLargeSessionCardDecoration;
